/*
  Previews a shade while its swatch is hovered.

  Hovering a swatch shows that value's name and shade descriptions in place of the current selection's, and moving away puts the current selection back. The shades of every variant of the component product are carried on the element as JSON, so there is nothing to fetch.

  The selection itself is never touched: that stays with the variant-radios/variant-selects element the swatches belong to.
 */
if (!customElements.get('bundle-component')) {
  class BundleComponent extends HTMLElement {
    connectedCallback() {
      this.nameTarget = this.querySelector('.bundle-variant-picker__value');
      this.descriptionTarget = this.querySelector('.bundle-variant-picker__description');
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));

      if (!this.fieldsets.length || !this.nameTarget) return;

      try {
        this.shades = JSON.parse(this.dataset.bundlePreview || '[]');
      } catch (error) {
        this.shades = [];
      }

      this.addEventListener('mouseover', this.onMouseOver.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));

      this.addEventListener('change', () => {
        this.previewing = false;
        this.baseline = null;
      });
    }

    onMouseOver(event) {
      const label = event.target.closest('label');
      const fieldset = label && label.closest('fieldset');

      if (!fieldset || !this.fieldsets.includes(fieldset)) {
        this.onMouseLeave();
        return;
      }

      const input = label.control;

      if (!input || input.disabled) {
        this.onMouseLeave();
        return;
      }

      if (!this.previewing && this.descriptionTarget) {
        this.baseline = this.descriptionTarget.innerHTML;
        this.previewing = true;
      }

      this.render(fieldset, input.value);
    }

    onMouseLeave() {
      this.render();
      this.previewing = false;
    }

    selectedValues() {
      return this.fieldsets.map(fieldset => {
        const checked = fieldset.querySelector('input:checked');
        return checked ? checked.value : '';
      });
    }

    render(previewFieldset, previewValue) {
      const values = this.selectedValues();

      if (previewFieldset) {
        const index = this.fieldsets.indexOf(previewFieldset);
        if (index !== -1) values[index] = previewValue;
      }

      this.nameTarget.textContent = values.filter(Boolean).join(' / ');

      if (!this.descriptionTarget) return;

      const shade = this.shades.find(entry =>
        (entry.values || []).every(value => values.includes(value))
      );

      if (!shade) {
        if (!previewFieldset && this.baseline != null) {
          this.descriptionTarget.innerHTML = this.baseline;
        }
        return;
      }

      this.descriptionTarget.replaceChildren(
        ...(shade.descriptions || []).map(description => {
          const row = document.createElement('div');
          row.className = 'bundle-variant-picker__shade';

          const label = document.createElement('strong');
          label.className = 'bundle-variant-picker__shade-label';
          label.textContent = description.label || '';

          const text = document.createElement('span');
          text.className = 'bundle-variant-picker__shade-text';
          text.textContent = description.description || '';

          row.append(label, text);
          return row;
        })
      );
    }
  }

  customElements.define('bundle-component', BundleComponent);
}
